export * from './zeile-korrigiert.interface';
